/*
 Encapsulates the maxance property of devis objects (DataDevis). It descibes a full maxance tarification session.
 It mirrors the back PHP structure /maxance/includes/TarificationMaxance :

    public $error = false; // If not false, then tarification is not valid
    public $M = []; // id => [ (List of formules)
        //  title=>(text description)
        //  M=>(prime annuelle hors taxes et frais),
        //  A=>(ibid pour fractionnement annuel)]
        // ]
    public $optionsObligatoires = []; // id => [ (List of mandatory options)
        //  title=>(text description)
        //  M=>(prime annuelle hors taxes et frais),
        //  A=>(ibid pour fractionnement annuel)]
        // ]
    public $options = []; // id => [ (List of options (by saying just "option" we imply non mandatory))
        //  title=>(text description)
        //  M=>(prime annuelle hors taxes et frais),
        //  A=>(ibid pour fractionnement annuel)]
        // ]
    public $fraisComptants = ['M'=>0,'A'=>0]; // [mensuel=>(float),annuel=>(float)]
    public $fraisTermes = ['M'=>0,'A'=>0]; // [mensuel=>(float),annuel=>(float)]
    public $taxeNonProratisable = ['M'=>0,'A'=>0]; // [mensuel=>(float),annuel=>(float)]
    public $ref = false; // Reference of the devis

*/

export default class DataMaxance {

    constructor(maxance,devis) {
        for ( const key in maxance ) {
            this[key] = maxance[key]
        }

        this.devis = devis
        this.formule = false
        this.fractionnement = false
        this.hasTarif = false
        this.outputFancy = false 
        this.fancyDeflt = '-'
        this.fancyPost = '  €'
    }

    setChoicesFromDevis() {
        this.setFormuleFromXena( this.devis.getValue('formule') )
        this.fractionnement = this.devis.getValue('periodicite')
        return this
    }

    setFormuleFromXena(xenaFormule) {
        if ( !this.M ) return this
        const id = {'M2':'1','M3':'2','M7':'4'}[xenaFormule]
        if ( !id ) {
            this.hasTarif = false
            this.formule = false
        } else {
            this.formule = Object.keys(this.M).find( key => ( key.length==3 )&&( key[1] == id[0] )&&( key[2] == '1' )  )
            if ( !this.formule ) {
                this.formule = Object.keys(this.M).find( key => ( key.length==3 )&&( key[1] == id[0] )&&( key[2] == '2' )  )
            }
            this.hasTarif = !!( this.formule && this.M[this.formule].M )
        }
        return this
    }

    setFormule(formule) {
        this.formule = formule
        this.hasTarif = this.M && this.M[formule] && this.M[formule].M
        return this
    }

    setFractionnement(fract) {
        this.fractionnement = fract
        return this
    }

    setAnnuel() { 
        this.fractionnement = 'A'
        return this
    }

    setMensuel() {
        this.fractionnement = 'M'
        return this
    }

    hasTarifs() {
        return !! this.M
    }

    hasAnything() {
        return this.hasTarifs() || this.error || this.calculating
    }

    prime() {
        return this.hasTarif ? Object.values(this.optionsObligatoires).reduce(
            (sum,opt) => parseFloat(opt[this.fractionnement]) + sum,
            parseFloat(this.M[this.formule][this.fractionnement])
        ) : 0 
    }

    coutTotal() {
        return this.hasTarif 
            ? this.prime() 
                + parseFloat( this.fraisTermes[this.fractionnement] )
                + parseFloat( this.taxeNonProratisable[this.fractionnement] )
            : 0
    }

    acompte() {
        return this.hasTarif
            ? (this.prime()*((this.fractionnement=='M')?0.0834:1.0))
                + parseFloat( this.fraisComptants[this.fractionnement] )
                + parseFloat( this.taxeNonProratisable[this.fractionnement] )
            : 0
    }

    echeance() {
        return this.hasTarif
            ? (this.prime()*0.0834)
            + ( parseFloat( this.fraisTermes[this.fractionnement] )*0.0834 )
        : 0
    }

    setFancy(deflt,post) {
        this.fancyDeflt = deflt
        this.fancyPost = post
        return this
    }

    fancyPrice(price) {
        const fprice = parseFloat(price)
        if ( !fprice ) return this.fancyDeflt
        const pm = DataMaxance.priceFormatter.format( fprice ).match(DataMaxance.regPrice)
        return pm ? <>{pm[1]}<sup>{pm[2]}</sup>{this.fancyPost}</> : fprice
    }
}

DataMaxance.regPrice = /^([\s0-9]+)(,[0-9]+)$/
DataMaxance.priceFormatter = new Intl.NumberFormat('fr-FR',{
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

